//@format
import { attachPolicy } from '../apis/auth';

import * as Sentry from '@sentry/react';

export const listener = async data => {
    switch (data?.payload?.event) {
        case 'customOAuthState':
            console.log('DOES THIS FIRE', data);
            break;
        case 'signOut':
            Sentry.setUser(null);
            window.location.replace('/');
            break;
        case 'signIn':
            Sentry.setUser({username: data.payload.data.username});
            await attachPolicy();
            break;
        default:
            break;
    }
};
